function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import getDisplayName from 'react-display-name';
import omit from 'lomit';
import createTween from './createTween';

var animateProps = function animateProps(AnimatedComponent, defaultProps) {
  if (defaultProps === void 0) {
    defaultProps = {};
  }

  var AnimateProps = /*#__PURE__*/function (_Component) {
    _inheritsLoose(AnimateProps, _Component);

    function AnimateProps(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.state = {};
      _this.tweens = {};
      props = Object.assign({}, defaultProps, props);

      if (props.hasOwnProperty('animatedProps') && typeof props.animatedProps === 'object') {
        Object.keys(props.animatedProps).forEach(function (key) {
          if (props.hasOwnProperty(key)) {
            _this.state[key] = props[key];
          }
        });
      }

      _this.onTweenProgress = _this.onTweenProgress.bind(_assertThisInitialized(_this));
      _this.onTweenComplete = _this.onTweenComplete.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = AnimateProps.prototype;

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var props = Object.assign({}, defaultProps, this.props);

      if (!props.hasOwnProperty('animatedProps')) {
        return;
      }

      Object.keys(props.animatedProps).forEach(function (key) {
        if (_this2.props[key] !== prevProps[key] && _this2.props[key] !== _this2.state[key]) {
          _this2.tweenProp({
            prop: key,
            value: _this2.state[key],
            target: _this2.props[key],
            tweenProps: props.animatedProps.hasOwnProperty(key) ? props.animatedProps[key] : {}
          });
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      var _this3 = this;

      if (this.tweens && this.tweens.length) {
        Object.keys(this.tweens).forEach(function (key) {
          _this3.tweens[key].stop();
        });
      }
    };

    _proto.onTweenProgress = function onTweenProgress(prop, _ref) {
      var _this$setState;

      var value = _ref.value;
      var props = Object.assign({}, defaultProps, this.props);
      var onAnimateProgress = props.onAnimateProgress;

      if (onAnimateProgress) {
        this.setState(onAnimateProgress(prop, value));
        return;
      }

      this.setState((_this$setState = {}, _this$setState[prop] = value, _this$setState));
    };

    _proto.onTweenComplete = function onTweenComplete(prop, _ref2) {
      var _this4 = this;

      var value = _ref2.value;
      var props = Object.assign({}, defaultProps, this.props);
      var onAnimateComplete = props.onAnimateComplete;
      var tweensActive = false;
      Object.keys(this.tweens).forEach(function (key) {
        if (_this4.tweens[key].active) {
          tweensActive = true;
        }
      });

      if (onAnimateComplete) {
        onAnimateComplete(prop, value, tweensActive);
      }
    };

    _proto.tweenProp = function tweenProp(_ref3) {
      var prop = _ref3.prop,
          value = _ref3.value,
          target = _ref3.target,
          tweenProps = _ref3.tweenProps;
      var tween = createTween({
        prop: prop,
        value: value,
        target: target,
        tweenProps: tweenProps
      }, this.onTweenProgress, this.onTweenComplete);
      return this.tweens[prop] = tween;
    };

    _proto.render = function render() {
      var props = Object.assign({}, defaultProps, this.props);
      var animatedPropsKeys = props.animatedProps ? Object.keys(props.animatedProps) : [];
      var cleanProps = omit(this.props, animatedPropsKeys);
      return React.createElement(AnimatedComponent, _extends({}, cleanProps, this.state));
    };

    return AnimateProps;
  }(Component);

  AnimateProps.displayName = "AnimateProps(" + getDisplayName(AnimatedComponent) + ")";
  return AnimateProps;
};

export default animateProps;